import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

interface FileUploader {

  upload(formData: FormData): Observable<any>;
}

/**
 * Serviço de upload dos arquivos de chuva e ocorrências.
 */
@Injectable({
  providedIn: 'root'
})
export class FileUploaderService implements FileUploader {

  constructor(private postRoute: string, private http: HttpClient) { }

  upload(formData: FormData) {
    return this.http.post(
      `${environment.serverBaseUrl}/${this.postRoute}`, 
      formData
    );
  }
}
